import { WORKTYPELIST_SEARCH, WORKTYPELIST_PAGE } from '../actions/worktypelistactions';

const state = { search:'', page:0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [WORKTYPELIST_SEARCH]: ({ commit }, search) => {
        commit(WORKTYPELIST_SEARCH, search);
    },
    [WORKTYPELIST_PAGE]: ({ commit }, page) => {
        commit(WORKTYPELIST_PAGE, page);
    }
};

const mutations = {
    [WORKTYPELIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [WORKTYPELIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};